import { PublicClientApplication } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { Avatar, Image } from "@fluentui/react-components";
import { ChevronDownRegular, ChevronUpRegular } from "@fluentui/react-icons";
import * as microsoftTeams from "@microsoft/teams-js";
import React from "react";
import { Link } from "react-router-dom";
import { $gray200 } from "../../../cssjs/colors";
import PageEnum from "../../../enum/PageEnum";
import UseGraph from "../../../hooks/useGraph";
import { CommonHelper } from "../../../utils/common/CommonHelper";
import signOut from "../images/signout.svg";
import { default as amaduesLogo } from "./../../../assests/amadeus.svg";
import { getAvatarImage } from "./getAvatarImage";
import { getNavBarStyles } from "./NavBarStyles";
const IconToggle = ({
  direction,
}: {
  direction?: boolean;
}): React.JSX.Element => (
  <span className={`${styles.iconColor} amd-container-vcenter`}>
    {direction ? <ChevronDownRegular /> : <ChevronUpRegular />}
  </span>
);

const styles = getNavBarStyles();
export const NavBar: React.FunctionComponent = () => {
  const msalInstance = useMsal().instance as PublicClientApplication;

  const [userProfilePhoto, setUserProfilePhoto] = React.useState<string>("");
  const [avatar, setAvatar] = React.useState<boolean>(false);
  const [userEmail, setUserEmail] = React.useState<string>("");
  const [username, setUsername] = React.useState<string>("");
  React.useEffect(() => {
    const fetchUserEmail = async () => {
      try {
        const email = (await CommonHelper.getLoggedInUser(
          microsoftTeams,
          msalInstance
        )) as string;
        setUsername(email.split("@")[0]);
        setUserEmail(email);
      } catch (_error) {
        console.log("error occurred");
      }
    };

    fetchUserEmail();
  }, []);

  const [open, setOpen] = React.useState<boolean>(false);
  const clickHandler = (): void => {
    setOpen((v) => !v);
  };
  const setUserPhoto = () => {
    const getCurrentUser = UseGraph(
      msalInstance,
      ["user.read"],
      "https://graph.microsoft.com/v1.0/me/photos/48x48/$value"
    );

    getCurrentUser?.then((response: any) => {
      response?.blob().then((data: any) => {
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onload = () => {
          const avatarImage = getAvatarImage(reader);
          setUserProfilePhoto(avatarImage);
        };
      });
    });
  };
  React.useEffect(() => {
    setUserPhoto();
  }, []);

  return (
    <>
      <div className={styles.header}>
        <div className="d-flex">
          <img
            src={amaduesLogo}
            alt="amadeus logo"
            style={{ cursor: "pointer", height: "15px", padding: "20px 30px" }}
          />
          <div className={`${styles.headerBrandName}`}>
            <Link to={`/${PageEnum.PageUrl.Home}`} className={` text-d-none`}>
              APOC
            </Link>
          </div>
        </div>
        <div
          className="pt-1 pr-sm-1 cursor-pointer d-flex"
          onClick={() => {
            setAvatar(!avatar);
            clickHandler();
          }}
        >
          <Avatar
            data-testid="avatar-image"
            image={{ src: userProfilePhoto }}
            style={{ top: "2px" }}
          />

          <span style={{ padding: "10px" }} title={userEmail}>
            {username}
          </span>
          {!open ? <IconToggle direction={true} /> : <IconToggle />}
        </div>
      </div>
      {avatar && (
        <div className={styles.headerSubNavItem}>
          <Link
            to="#"
            onClick={CommonHelper.logoutUser(msalInstance)}
            className={`amd-container-vcenter text-d-none fw-400 fs-16 pa-2`}
            style={{ borderTop: `1px solid  ${$gray200}` }}
          >
            <span style={{ width: 20 }}>
              <Image src={signOut} />
            </span>
            <span className="ml-2 fc--gray800">Sign out</span>
          </Link>
        </div>
      )}
    </>
  );
};
